import { render, staticRenderFns } from "./VoyageSummaryCard.vue?vue&type=template&id=aee1560c&scoped=true&"
import script from "./VoyageSummaryCard.vue?vue&type=script&lang=js&"
export * from "./VoyageSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./VoyageSummaryCard.vue?vue&type=style&index=0&id=aee1560c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee1560c",
  null
  
)

export default component.exports